import type { ValueOf } from 'cpool-utils/src/typeUtils';

export const SwitchSize = {
    DEFAULT: 'default',
    SM: 'sm',
} as const;

export type SwitchSizeType = ValueOf<typeof SwitchSize>;
